module.exports = __webpack_public_path__ + "static/media/user.00cab4ca.png";